import React from "react";

function SvgDependants({
  color = "currentColor",
  width = 20,
  height = 20,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M16 4C15.45 4 14.9792 3.80417 14.5875 3.4125C14.1958 3.02083 14 2.55 14 2C14 1.45 14.1958 0.979167 14.5875 0.5875C14.9792 0.195833 15.45 0 16 0C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2C18 2.55 17.8042 3.02083 17.4125 3.4125C17.0208 3.80417 16.55 4 16 4ZM15 20V12C15 11.3333 14.8292 10.7333 14.4875 10.2C14.1458 9.66667 13.7083 9.25 13.175 8.95L14.05 6.375C14.1833 5.95833 14.4292 5.625 14.7875 5.375C15.1458 5.125 15.55 5 16 5C16.45 5 16.8542 5.125 17.2125 5.375C17.5708 5.625 17.8167 5.95833 17.95 6.375L20.5 14H18V20H15ZM10.5 9.5C10.0833 9.5 9.72917 9.35417 9.4375 9.0625C9.14583 8.77083 9 8.41667 9 8C9 7.58333 9.14583 7.22917 9.4375 6.9375C9.72917 6.64583 10.0833 6.5 10.5 6.5C10.9167 6.5 11.2708 6.64583 11.5625 6.9375C11.8542 7.22917 12 7.58333 12 8C12 8.41667 11.8542 8.77083 11.5625 9.0625C11.2708 9.35417 10.9167 9.5 10.5 9.5ZM3.5 4C2.95 4 2.47917 3.80417 2.0875 3.4125C1.69583 3.02083 1.5 2.55 1.5 2C1.5 1.45 1.69583 0.979167 2.0875 0.5875C2.47917 0.195833 2.95 0 3.5 0C4.05 0 4.52083 0.195833 4.9125 0.5875C5.30417 0.979167 5.5 1.45 5.5 2C5.5 2.55 5.30417 3.02083 4.9125 3.4125C4.52083 3.80417 4.05 4 3.5 4ZM1.5 20V13H0V7C0 6.45 0.195833 5.97917 0.5875 5.5875C0.979167 5.19583 1.45 5 2 5H5C5.55 5 6.02083 5.19583 6.4125 5.5875C6.80417 5.97917 7 6.45 7 7V13H5.5V20H1.5ZM9 20V16H8V12C8 11.5833 8.14583 11.2292 8.4375 10.9375C8.72917 10.6458 9.08333 10.5 9.5 10.5H11.5C11.9167 10.5 12.2708 10.6458 12.5625 10.9375C12.8542 11.2292 13 11.5833 13 12V16H12V20H9Z"
        fill={color}
      />
    </svg>
  );
}

export default SvgDependants;
